module.exports = __webpack_public_path__ + "img/1556525314.738f5462.jpg";